'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToggleInput = require('../../../../../components/form/fields/ToggleInput');

var _ToggleInput2 = _interopRequireDefault(_ToggleInput);

require('./EmailPreferenceToggle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var EmailPreferenceToggle = function EmailPreferenceToggle(_ref) {
    var value = _ref.value,
        active = _ref.active,
        label = _ref.label,
        updatePreference = _ref.updatePreference;
    return _react2.default.createElement(
        'li',
        { className: 'EmailPreferenceToggle' },
        _react2.default.createElement(_ToggleInput2.default, { label: label, value: value, active: active, onChange: updatePreference })
    );
};

// Styles


EmailPreferenceToggle.propTypes = {
    updatePreference: _propTypes2.default.func.isRequired,
    active: _propTypes2.default.bool,
    value: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.string.isRequired
};

exports.default = EmailPreferenceToggle;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/email/EmailPreferenceToggle.js
// module id = 776
// module chunks = 0